import React from 'react'
import {useSelector} from 'hooks/redux'
import {Presenter} from './Presenter'

export const Completed = () => {
  const email = useSelector((state) => state.registration.email)
  return <Presenter email={email} />
}
